import { BacksplashData, BacksplashDataIn } from './types';
import { panelData } from './panel.data';

export const backsplashData = (dataIn: Partial<BacksplashDataIn> = null): BacksplashData => {
	const basePanelData = panelData(dataIn);

	const record: BacksplashData = {
		...basePanelData,
		associatedPanelId: dataIn?.associatedPanelId ?? null,
		centerOffset: dataIn?.centerOffset ?? 0,
		pairedBacksplashId: dataIn?.pairedBacksplashId ?? null,
		pairingSide: dataIn?.pairingSide ?? null,
		leftAdjoiningDepth: dataIn?.leftAdjoiningDepth ?? 0,
		rightAdjoiningDepth: dataIn?.rightAdjoiningDepth ?? 0,
		widthOverride: dataIn?.widthOverride ?? null,
		horizontalAlign: dataIn?.horizontalAlign ?? 'left',
		manualOffset: dataIn?.manualOffset ?? 0
	};

	return record;
};
